import { StateSelector } from 'reduxm/modules/selectors'
import { connect } from 'react-redux'
import { CreatedOrder } from './index'

const mapStateToProps = state => ({
	createOrderState: StateSelector.cart.createOrder(state)
})

export const CreatedOrderStore = connect(mapStateToProps, null)(CreatedOrder)
